import React from 'react'
import './style.css'
import PropTypes from 'prop-types'
import NRTHorizontalStack from "../../../../components/_common/_containers/HorizontalStack"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"
import NRTFormContainer from "../../../../components/_common/_form/_containers/FormContainer"
import NRTButton from "../../../../components/_common/_buttons/Button"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager"
import NRTFormUserSignIn from "../../../../components/FormUserSignIn"
import _ from "lodash"
import {PersonTypeEnum} from "../../../../enums/PersonTypeEnum"

const SIMULATE_LOGIN_ERROR = false

class AuthenticateStep extends React.Component {

    state = {
        awaiting: false,
        loginFail: false
    }


    tryLogin = (login, password) => {

        const {schema} = this.props

        this.setState({
            awaiting: true,
            loginFail: false,
        }, () => {

            this.props.tryLogin(schema, login, password)
                .then(({success, person}) => {

                    if (success) {
                        const types = _.get(person, 'types', '')
                        const isTeacher = types.split('|').some(type => type === PersonTypeEnum.TEACHER + '')
                        this.props.context.set({
                            person,
                            isTeacher
                        }, () => this.props.goToNextStep())
                    } else {
                        this.setState({
                            loginFail: true,
                            awaiting: false,
                        })
                    }
                })
                .catch(this.onError)

        })
    }


    onError = (error) => {
        console.error(error)
        this.setState({awaiting: false})

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: 'Ocorreu um erro na inesperado. Por favor tente novamente mais tarde.'
            }
        })

        this.props.context.logError(error)
    }


    formChanged = (form) => {
        this.setState({
            formValid: form.valid,
            ...form.values
        })
    }


    render() {

        const {
            loginFail,
            awaiting
        } = this.state

        return (
            <NRTFormContainer className={'nrt-authenticate-step'}>
                <NRTHorizontalStack smFractions={[1]}>

                    <NRTFormContainer title={'Login'}>
                        <NRTVerticalStack>

                            <NRTFormStateManager onStateChange={this.formChanged}>

                                <NRTFormUserSignIn
                                    loginFail={loginFail}
                                    awaiting={awaiting}
                                    onSubmit={this.tryLogin}
                                    goToForgotPassword={this.props.goToForgotPassword}
                                />


                            </NRTFormStateManager>

                        </NRTVerticalStack>
                    </NRTFormContainer>

                    <NRTFormContainer title={'Novo cadastro'}
                                      className={'sign-in-form'}>
                        <p>Não possui conta? Faça seu cadastro aqui.</p>

                        <NRTButton
                            onClick={this.props.goToNextStep}
                            style={{maxWidth: '20rem', marginTop: '1rem'}}
                            content={'NOVO CADASTRO'}
                            actionButton
                        />


                    </NRTFormContainer>
                </NRTHorizontalStack>

            </NRTFormContainer>
        )
    }
}

AuthenticateStep.propTypes = {
    context: PropTypes.object.isRequired,
    schema: PropTypes.string.isRequired,
    tryLogin: PropTypes.func.isRequired,
    goToNextStep: PropTypes.func.isRequired,
    goToForgotPassword: PropTypes.func.isRequired,
}

AuthenticateStep.defaultProps = {}


export default AuthenticateStep



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/AuthenticateStep/index.js